import useSWR from 'swr';

import { fetcher } from '../index';
import type { ProcessorRecord, LmqStatus, ProcessStatus } from '../../interfaces/lisa';

interface ProcessorStatusResponse {
    data: ProcessorRecord[];
    counts: Record<LmqStatus, number>;
    process: ProcessStatus;
}

export default function useLisaProcessorStatus(refreshInterval = 0) {
    const { data, error, mutate } = useSWR<ProcessorStatusResponse>(
        '/v1/dashboard/lisa/processor-status',
        fetcher,
        { refreshInterval }
    );

    return {
        records: data?.data ?? [],
        counts: data?.counts ?? {} as Record<string, number>,
        process: data?.process ?? null,
        isLoading: !data && !error,
        error,
        refresh: mutate,
    };
}
